module.exports = __webpack_public_path__ + "img/blackBoxModel1.54a1685e.png";